<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}结算标准
          <span v-show="!this.dataId==0">结算表：[{{this.dataId}}]</span>
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  标准名称
                </th>
                <td colspan="3">
                  <el-input type="text"    v-model="formData.name" :maxlength="30" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  状态
                </th>
                <td>
                  <el-select v-model="formData.stat" style="width: 165px;">
                    <el-option label="未生效" :value="0"/>
                    <el-option label="生效" :value="1"/>
                    <el-option label="做废" :value="9"/>
                  </el-select>
                </td>





              </tr>
              <tr>



                <th>
                  <em class="f-red">*</em>
                  服务类型
                </th>
                <td>
                  <!--                    <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeName" clearable />-->
                  <el-select v-model="formData.serverTypeId" placeholder="请选择产品类型"
                             clearable>
                    <el-option v-for="item in serviceTypeOption" :key="item.value" :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>品牌
                </th>
                <td>
                  <el-select  :disabled="readonlyField" v-model="formData.brandId" placeholder="请选择品牌" style="width: 165px;" clearable>
                    <el-option v-for="item in brandOptions" :key="item.value" :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <!--                  <el-input :readonly="readonlyField" v-model="formData.brandName"/>-->
                </td>


                <th>
                  <em class="f-red">*</em>产品类型
                </th>
                <td>
                  <el-select :disabled="readonlyField" v-model="formData.bigCategoryId" placeholder="产品大类"
                             @change='productSelectOne'
                             style="width: 49%!important;">
                    <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select :disabled="readonlyField" v-model="formData.smallCategoryId" placeholder="产品小类"
                             clearable
                             style="width: 49%!important;margin-left:2%;">
                    <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  保修类型
                </th>
                <td>
                  <el-select v-model="formData.guaranteeType">
                    <el-option label="保内" :value="1"/>
                    <el-option label="保外" :value="2"/>
                  </el-select>
                </td>

                <th>
                  <em class="f-red">*</em>
                 区域结算等级
                </th>
                <td>
                  <el-select v-model="formData.settleLevel">
                    <el-option label="默认" :value="0"/>
                    <el-option label="一级" :value="1"/>
                    <el-option label="二级" :value="2"/>
                    <el-option label="三级" :value="3"/>
                    <el-option label="四级" :value="4"/>

                  </el-select>
                </td>

      <th>
                  <em class="f-red">*</em>
                  购买渠道
                </th>
                <td>
                  <el-select v-model="formData.buyChannelId" placeholder="购买渠道" style="width: 165px;">
                    <el-option v-for="item in buyChannelOption" :key="item.buyChannelName" :label="item.buyChannelName"
                               :value="item.id"/>
                  </el-select>
                </td>


              </tr>
              <tr>



                <th>
<!--                  <em class="f-red">*</em>-->
                  网点名称
                </th>
                <td>
                  <el-input style="width: 165px;" type="text" autocomplete="off" v-model="formData.siteName" clearable :readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog2=true"></i>
                  </el-input>
                </td>

                <th>
                  网点性质
                </th>
                <td>
                    <el-select v-model="formData.siteTypeId" placeholder="网点性质" style="width: 165px;">
                    <el-option v-for="item in siteTypeOption" :key="item.value" :label="item.label"
                               :value="item.value"/>
                  </el-select>
                </td>

                <th>
                  产品名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable :readonly="true" style="width: 165px;">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i>
                  </el-input>
                  <!--                    <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeName" clearable />-->
                </td>





              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  结算标准
                </th>
                <td>
                  <!-- <el-input type="number" oninput="if(value<0||value>9999)value=0" autocomplete="off"
                            v-model="formData.price" clearable/> -->
                  <el-input type="text"  autocomplete="off" style="width: 165px;" v-model="formData.price" clearable/>
                </td>


                <th>
                  <em class="f-red">*</em>
                  红利
                </th>
                <td>
                  <!-- <el-input type="number" oninput="if(value<0||value>9999)value=0" autocomplete="off"
                            v-model="formData.price" clearable/> -->
                  <el-input type="text"  autocomplete="off" style="width: 165px;" v-model="formData.bonusFee" clearable/>
                </td>
</tr>
              <tr style="position: relative;height: 36px;">
                <th>
                  <em class="f-red">*</em>有效时间
                </th>
                <td colspan="3">
                  <el-date-picker class="current-date-picker"
                                  v-model="formData.date"
                                  type="daterange"
                                  align="right"
                                  unlink-panels
                                  range-separator="-"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format='yyyy-MM-dd'>
                  </el-date-picker>
                </td>

              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog" :multi="true"/>
    <!--    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"-->
    <!--      @confirm="confirmCategory" />-->
    <sitePop v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" :multi="true"
             @commit="commitSelectedRow1"/>
  </div>
</template>
<script>
import {dictType, loadDictData} from "@/config/dictType"
import Tinymce from '@/components/Tinymce';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue';
import api from "@/api/projectApi";
import {fetchTree} from "@/api/admin/type_tree";

export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    preconditionDialog,
    sitePop,

    Tinymce,
  },
  data() {
    return {
      getDataUrl: '/basic/sfSettleStandard/getById',
      addDataUrl: '/basic/sfSettleStandard/add',
      updateDataUrl: '/basic/sfSettleStandard/update',
      getBrandListUrl: '/basic/snCompanyBrand/getBrandList',
      getServiceTypeUrl: '/basic/basServiceType/getList',
      getItemCategoryTypeUrl: '/basic/basItemCategory/getList',
      getInitUrl: '/basic/sfSettleStandard/init',

      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      tenant: {
        status: 0,
        tenantAttachmentDTOs: []
      },


      showProductCategoryDialog: false,
      showPreconditionDialog: false,
      showPreconditionDialog2: false,

      formData: {
        id: '',  // 主键id,自动新增
        createBy: '',  // 创建人
        createTime: '',  // 创建时间
        name: '',  // 标准名称
        guaranteeType: 1,  // 保修类型：1保内、2保外
        serverTypeId: '',  // 服务类型Id:关联服务类型表bas_service_type.id
        brandId: null,  // 品牌ID,关联sn_company_brand.id
        bigCategoryId: null,  // 产品大类ID,关联bas_item_category.id
        smallCategoryId: null,  // 产品小类ID,关联bas_item_category.id
        itemId: null,  // 产品id，关联bas_item.id字段
        siteLevelId: '',  // 网点等级ID，关联脚手架数据字典项目表.id
        siteTypeId: '', //网点性质ID，关联脚手架数据字典项目表.id
        siteId: '',  // 网点ID,关联sn_user.id;
        settleLevel: 0,  // 区域结算等级；0默认、1一级、2二级、3三级、4四级;
        buyChannelId: '', //购买渠道ID,关联bas_buy_channel.id
        beginDate: '',  // 开始时间，注意格式为年月日  yyyy-mm-dd
        endDate: '',  // 结束时间，注意格式为年月日  yyyy-mm-dd
        price: 0,  // 服务费
        bonusFee : 0, //红利
        stat: 1,  // 状态：0未生效；1生效；9做废
        itemName: '',  // 显示用,
        siteName: null,
        bigCategoryName: '',
        smallCategoryName: '',
        brandName: null,
        date: null
      },
      brandOptions: [],
      serviceTypeOption: [],
      productOptions0: [],
      productOptions1: [],
      siteLevelOption: [],
      siteTypeOption: [],
      buyChannelOption: [],
    }
  },

  computed: {
    readonlyField() {
      return this.formData.itemId != null
    }
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  watch: {

  },
  mounted() {
    this.getData()
    this.loadDictData()
    this.loadBrandOption()
    this.loadServiceTypeOptions()
    this.loadProductOption0()
    this.loadBuyChannelOptions()
  },
  methods: {
    // 网点选中
    commitSelectedRow1(data) {
      console.log(data, '网点选中')
      this.formData.siteId = data.id
      this.formData.siteName = data.name
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: this.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = [{label: '全部', value: '0'}]
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = [{label: '全部', value: '0'}]
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 加载产品小类
    loadProductOption1() {
      if (this.formData.bigCategoryId === ''
        || this.formData.bigCategoryId === null
        || this.formData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          usable: 1,  // 加载启用的
          parentId: this.formData.bigCategoryId
        }).then(response => {
          this.productOptions1 = [{label: '全部', value: '0'}]
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },

    // 产品大类选中加载小类
    productSelectOne() {
      this.formData.smallCategoryId = null
      this.productOptions1 = []
      this.loadProductOption1()
    },

    // 加载服务类型
    loadServiceTypeOptions() {
      this.$http({
        url: this.getServiceTypeUrl,
        method: 'post',
        data: {
          parentId: 0
        }
      }).then(res => {
        res.data.data.forEach(item => {
          this.serviceTypeOption.push({
            label: item.serviceTypeName,
            value: item.id
          })
        })
      })
    },

    //加载购买渠道
    loadBuyChannelOptions() {
      this.$http({
        url: this.getInitUrl,
        method: 'post',
      }).then(res => {
        let data = res.data.data
        this.buyChannelOption = data.basBuyChannelList
        console.log("buyChannelOption",this.buyChannelOption)
      })
    },

    // 加载数据字典中网点等级
    loadDictData() {
      loadDictData(dictType.siteQuality).then(res => {
        this.siteTypeOption = []
        res.data.data.forEach(item => {
          this.siteTypeOption.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // 产品选中，带出产品大类小类与品牌
    commitSelectedRow(data) {
      console.log(data)
      this.formData.itemId = data.id
      this.formData.itemName = data.itemName
      this.$http({
        url: api.basItem.getDataUrl,
        method: 'post',
        data: {id: data.id}
      }).then(res => {
        let data1 = res.data.data;
        /*this.formData.smallCategoryId = data1.smallCategoryId
        this.formData.bigCategoryId = data1.bigCategoryId
        this.formData.brandId = data1.brandId*/
        this.formData.smallCategoryId = null
        this.formData.bigCategoryId = null
        this.formData.brandId = null
        // this.$http({
        //   url: api.basItemCategory.getDataUrl,
        //   method: 'post',
        //   data: {id: this.formData.smallCategoryId}
        // }).then(res => {
        //   this.formData.smallCategoryName = res.data.data.categoryName
        // })
        // this.$http({
        //   url: api.basItemCategory.getDataUrl,
        //   method: 'post',
        //   data: {id: this.formData.bigCategoryId}
        // }).then(res => {
        //   this.formData.bigCategoryName = res.data.data.categoryName
        // })
        // this.$http({
        //   url: api.snCompanyBrand.getDataUrl,
        //   method: 'post',
        //   data: {id: this.formData.brandId}
        // }).then(res => {
        //   this.formData.brandName = res.data.data.brandName
        // })
      })
    },

    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data || {}
          let tempList = []
          tempList.push(data.beginDate)
          tempList.push(data.endDate)
          data.date = tempList
          this.formData = data
          this.loadProductOption1()
          console.log("formData",this.formData)
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (this.formData.itemId === null){
          if (this.formData.brandId === null){
            this.$message.warning('请选择品牌')
            return
          }
          if (this.formData.bigCategoryId === null){
            this.$message.warning('请选择产品类型')
            return
          }
        }
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            let date = this.formData.date;
            if (date != null && date.length > 0) {
              this.formData.beginDate = date[0]
              this.formData.endDate = date[1]
            }
            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('editViewDataUpdate')
              this.$baseReload()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      })
    },

  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 165px !important;
// }

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.current-date-picker {
  width: 100%;
  border-radius: 2px;
  border-color: #e8e8e8;
  padding: 0 24px 0 8px;
  height: 28px !important;
  line-height: 28px;
}
.current-date-picker[data-v-b58b35ce] {
    width: 85%!important;
    border-radius: 2px;
    border-color: #e8e8e8;
    padding: 0 0px 0 8px!important;
    height: 28px !important;
    line-height: 28px;
}
</style>
